<template>
  <div class="content">
    <div class="row justify-content-center">
      <h3 class="text-center">{{$t('app.stats')}}</h3>
    </div>
    <div class="row">
      <div class="col-md-7 col-12">
        <user-comments-linechart/>
      </div>
      <div class="col-md-5 col-12">
        <user-debts-stats-doughnutchart/>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <user-payments-linechart/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    UserCommentsLinechart: () => import('@/components/employee/stats/charts/lineChart/comments'),
    UserDebtsStatsDoughnutchart: () => import('@/components/employee/stats/charts/doughnutChart/debtsStats'),
    UserPaymentsLinechart: () => import('@/components/employee/stats/charts/lineChart/payments'),
  },
};
</script>
